import { schema as schemaTypes } from 'normalizr'

import * as schemas from '../Schemas'

export const SCHEMA_LOOKUP = Object.values(schemas).reduce((lookup, schema) => (
  schema instanceof schemaTypes.Entity
    ? { ...lookup, [schema.key]: schema }
    : lookup
), {})
